import { FLAGS } from '@iheartjane/feature-flags';
import { CompareProducts, WizardButton } from '@iheartjane/menu';
import { Button, SparkleIcon } from '@iheartjane/reefer';
import { SEARCH_POSITION } from '@iheartjane/types';

import type { MobileFiltersModalProps } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';
import { MobileFiltersModal } from '@jane/bloom/components/productListingPage/categoryAndFilterSelectors/filterSelector/mobileFiltersModal';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';

import { SearchFieldButton } from '../../search/searchFieldButton';

import styles from './mobileFilterRow.module.css';

interface MobileFilterRowProps extends MobileFiltersModalProps {
  hideSearch?: boolean;
  onWizardClick?: () => void;
  showCompare?: boolean;
}

export const MobileFilterRow = ({
  hideSearch,
  onWizardClick,
  showCompare = false,
  ...props
}: MobileFilterRowProps) => {
  const { featureFlags, theme } = useRootLoaderData();
  const useCustomComponents = featureFlags?.[FLAGS.c2CustomComponents] ?? false;
  const showSplitWizardButton =
    onWizardClick &&
    (useCustomComponents
      ? theme?.bloom?.search?.position === SEARCH_POSITION.split
      : true);
  return (
    <div className={styles['mobileFilterRow']}>
      {!hideSearch &&
        !!useCustomComponents &&
        theme?.bloom?.search?.position === SEARCH_POSITION.filters && (
          <>
            <SearchFieldButton />
            {onWizardClick && (
              <Button.Icon
                variant="primary"
                icon={<SparkleIcon color="grays-white" />}
                label="Help me choose"
                ariaLabel="Help me choose"
                onClick={onWizardClick}
              />
            )}
          </>
        )}
      <MobileFiltersModal {...props} />
      {showSplitWizardButton && (
        <div className={styles['mobileActionSlot']}>
          <WizardButton onClickStart={onWizardClick} />
        </div>
      )}
      {!useCustomComponents && showCompare && <CompareProducts.Button />}
    </div>
  );
};
